export const DisplayPhoneNumber = (num: string) => {
  return num.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}
